import React, { useState } from "react";
import CardChevron from "@/Components/Common/CardChevron";
import { useIntl } from "react-intl";
import { StationsListType } from "../../Orchestrator/Types/Index";
import stopManager from "../../Lib/Utils/StopManager";
import { getIconForType } from "../../Components/LandingPage/FromDropDown/GetIconForType";

type SimpleLocationPopupProps = {
  visible: boolean;
  locations: StationsListType | undefined;
  onSelect: (id: string, name: string) => void;
  showAllStations?: boolean;
};

const LiveScheduleLocationPopup: React.FC<SimpleLocationPopupProps> = ({
  visible,
  locations,
  onSelect,
  showAllStations = true,
}) => {
  const intl = useIntl();
  const [openDropdowns, setOpenDropdowns] = useState<Record<string, boolean>>(
    {}
  );

  const toggleDropdown = (id: string) => {
    setOpenDropdowns((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  if (!visible) return null;

  const safeLocations = locations || [];

  return (
    <div className="location-popup simple-location-popup">
      {showAllStations && (
        <div
          className="simple-location-item"
          onClick={() =>
            onSelect("", intl.formatMessage({ id: "scheduleAllStations" }))
          }
        >
          <span className="simple-location-title">
            {intl.formatMessage({ id: "scheduleAllStations" })}
          </span>
        </div>
      )}

      {safeLocations.map((loc) => {
        const name = stopManager.getStopNameById(loc.id);
        const subStations = (loc as any)?.subStations || [];
        const isOpen = !!openDropdowns[loc.id];
        const iconType =
          subStations.length > 0 ? "direction" : (loc as any)?.type || "";

        return (
          <div key={loc.id}>
            <div
              className="simple-location-item"
              onClick={() => {
                if (subStations.length > 0) {
                  toggleDropdown(loc.id);
                } else {
                  onSelect(loc.id, name);
                }
              }}
            >
              <span className="simple-location-icon">
                {getIconForType(iconType)}
              </span>
              <span className="simple-location-title">{name}</span>
              {subStations.length > 0 && (
                <span
                  className="simple-location-arrow"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleDropdown(loc.id);
                  }}
                >
                  <CardChevron
                    direction={isOpen ? "up" : "down"}
                    width={10}
                    height={10}
                  />
                </span>
              )}
            </div>

            {isOpen &&
              subStations.map((sub: any) => {
                const subName = stopManager.getStopNameById(sub.id);
                return (
                  <div
                    key={sub.id}
                    className="simple-location-item simple-location-sub"
                    onClick={() => onSelect(sub.id, subName)}
                  >
                    <span className="simple-location-icon">
                      {getIconForType(sub?.type || "bus")}
                    </span>
                    <span className="simple-location-title">{subName}</span>
                  </div>
                );
              })}
          </div>
        );
      })}
    </div>
  );
};

export default LiveScheduleLocationPopup;

